export const formatDateUS = (date?: string | null) => {
  if (!date) return ''

  return new Date(date).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })
}
